// The instances the whole game shares. sketch.ts creates them in preload and
// setup, and input.ts swaps in a new game. Other modules import them and always
// see the current one (ES module bindings are live).
import type { Game } from './game/game'
import type { Menu } from './menu/menu'
import type { Music } from './music'
import type { ScoreBoard } from './scoreboard'
import type { Snakes } from './snakes'
import type { GameSounds } from './utils/interfaces'

export let gameSounds: GameSounds
export let scoreboard: ScoreBoard
export let snakes: Snakes
export let music: Music
export let game: Game
export let menu: Menu

export function setGameSounds(value: GameSounds) {
    gameSounds = value
}
export function setScoreboard(value: ScoreBoard) {
    scoreboard = value
}
export function setSnakes(value: Snakes) {
    snakes = value
}
export function setMusic(value: Music) {
    music = value
}
export function setGame(value: Game) {
    game = value
}
export function setMenu(value: Menu) {
    menu = value
}
